import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const netskope = defineConnector({
  identifier: "netskope",
  name: "Netskope",
  tagLine: "Cloud security and SASE",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://.*\\.goskope\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "Netskope-Api-Token", value: app.secret.apiToken }]),
  steps: [
    {
      title: "Create an API token in Netskope",
      items: [
        {
          kind: "markdown",
          content: `1. In Netskope, go to **Settings › Tools › REST API v2**
2. Create a new token
3. Copy the token value`,
        },
      ],
    },
    {
      title: "Enter your Netskope details",
      items: [
        {
          kind: "hostname",
          label: "Tenant name",
          required: true,
          placeholder: "acme",
          target: { kind: "configuration", field: "tenant" },
          helperText:
            "Your Netskope tenant name (e.g., “acme” for acme.goskope.com).",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ tenant }) => `https://${tenant}/api/v2/tenant/info`,
  },
  publicEnvVars: ({ tenant }) => ({
    NETSKOPE_URL: tenant ? `https://${tenant}.goskope.com` : "",
  }),
});
